module.exports = __webpack_public_path__ + "img/il-item-not-found.a1908e7.svg";